// /utils/timeUtils.js

// Map of common IANA timezones to human-readable abbreviations
export const tzMap = {
  // North America
  "America/New_York": "EST",
  "America/Chicago": "CST",
  "America/Denver": "MST",
  "America/Los_Angeles": "PST",
  "America/Phoenix": "MST",
  "America/Toronto": "EST",
  "America/Vancouver": "PST",
  "America/Mexico_City": "CST",

  // South America
  "America/Sao_Paulo": "BRT",
  "America/Buenos_Aires": "ART",
  "America/Lima": "PET",
  "America/Bogota": "COT",
  "America/Santiago": "CLT",

  // Europe
  "Europe/London": "GMT",
  "Europe/Paris": "CET",
  "Europe/Berlin": "CET",
  "Europe/Madrid": "CET",
  "Europe/Rome": "CET",
  "Europe/Athens": "EET",
  "Europe/Moscow": "MSK",
  "Europe/Istanbul": "TRT",
  "Europe/Warsaw": "CET",
  "Europe/Kiev": "EET",

  // Africa
  "Africa/Johannesburg": "SAST",
  "Africa/Cairo": "EET",
  "Africa/Lagos": "WAT",
  "Africa/Nairobi": "EAT",
  "Africa/Casablanca": "WET",

  // Asia
  "Asia/Kolkata": "IST",
  "Asia/Calcutta": "IST", // alias
  "Asia/Dubai": "GST",
  "Asia/Karachi": "PKT",
  "Asia/Kathmandu": "NPT",
  "Asia/Dhaka": "BST",
  "Asia/Bangkok": "ICT",
  "Asia/Singapore": "SGT",
  "Asia/Hong_Kong": "HKT",
  "Asia/Tokyo": "JST",
  "Asia/Shanghai": "CST",
  "Asia/Seoul": "KST",
  "Asia/Jakarta": "WIB",
  "Asia/Manila": "PHT",
  "Asia/Riyadh": "AST",
  "Asia/Tehran": "IRST",
  "Asia/Jerusalem": "IST",

  // Oceania
  "Australia/Sydney": "AEST",
  "Australia/Melbourne": "AEST",
  "Australia/Brisbane": "AEST",
  "Australia/Perth": "AWST",
  "Pacific/Auckland": "NZST",
  "Pacific/Fiji": "FJT",

  // Middle East
  "Asia/Baghdad": "AST",
  "Asia/Kuwait": "AST",
  "Asia/Qatar": "AST",

  // Others
  "UTC": "UTC",
  "Etc/UTC": "UTC",
  "Etc/GMT": "GMT",
};


/**
 * Get the user's system timezone abbreviation
 */
export const getUserTimezoneInfo = () => {
  const tzName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const tzAbbr = tzMap[tzName] || tzName;
  return { tzName, tzAbbr };
};

/**
 * Format a Date object to local time string (HH:MM:SS AM/PM)
 */
export const formatLocalTime = (date) => {
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

/**
 * Format a Date object to MM-DD-YY (e.g., 09-30-25)
 */
export const formatLocalDate = (date) => {
  return date.toLocaleDateString("en-US", {
    month: "short", // Sep
    day: "2-digit", // 30
    year: "numeric", // 2025
  });
};

/**
 * Combine date + time + timezone abbreviation
 */
export const formatLocalDateTime = (date) => {
  const time = formatLocalTime(date);
  const localDate = formatLocalDate(date);
  const { tzName, tzAbbr } = getUserTimezoneInfo();
  return `${time} ${tzName} (${tzAbbr})`;
};
